
export default {
  'footer.platform': 'Plataforma',
  'footer.explore': 'Explorar',
  'footer.how_it_works': 'Cómo funciona',
  'footer.pricing': 'Precios',
  'footer.security': 'Seguridad',
  
  'footer.resources': 'Recursos',
  'footer.blog': 'Blog',
  'footer.faq': 'Preguntas frecuentes',
  'footer.safety_tips': 'Consejos de seguridad',
  'footer.support': 'Soporte',
  
  'footer.legal': 'Legal',
  'footer.terms': 'Términos y condiciones',
  'footer.privacy': 'Política de privacidad',
  'footer.cookies': 'Política de cookies',
  'footer.content_policy': 'Política de contenido',
  
  'footer.rights': 'Todos los derechos reservados',
  'footer.currency': 'Moneda',
  'footer.about': 'Acerca de nosotros',
  'footer.contact': 'Contáctenos',
  'footer.copyright': 'Todos los derechos reservados',
  'footer.language': 'Idioma',
};
